import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { formatPercent } from 'utils';
import { newPalette as palette } from 'components/Charts/Utils/colors';
import { Tooltip } from 'components/Base';
import {
  getGroupedSectors,
  getSubSectors
} from 'components/Charts/Utils/breakdowns';

const useStyles = makeStyles({
  '@global': {
    '.MuiTooltip-tooltip': {
      maxWidth: '500px'
    }
  },
  container: {
    width: '100%',
    fontSize: '0.9em'
  },
  color: {
    minWidth: '0px',
    borderRadius: '2px',
    height: '20px'
  },
  box: {
    display: 'flex',
    alignItems: 'center',
    padding: '3px 0 0',
    justifyContent: 'space-between',
    width: '100%'
  },
  name: {
    margin: '2px 0'
  },
  flexGrow: {
    flexGrow: 1
  },
  valueBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '4rem',
    fontWeight: 500
  },
  colorBox: {
    width: '18px',
    height: '18px',
    minWidth: '18px',
    minHeight: '18px',
    maxHeight: '18px',
    marginRight: '8px;',
    borderRadius: '50%'
  },
  itemBox: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  bold: {
    fontWeight: 'bold'
  },
  big: {
    fontSize: '20px'
  }
});
const Legend = ({ data, isForReport = false, isForFactSheet = false }: any) => {
  const classes = useStyles();

  const groups = getGroupedSectors();
  const subKeys = getSubSectors();

  const mappedGroups = groups
    .map((group: any) => {
      return {
        ...group,
        value: group.items
          .map(
            (key: string) =>
              data.find((entry: any) => entry.name === key)?.value || 0
          )
          .reduce(
            (accumulator: any, currentValue: any) => accumulator + currentValue,
            0
          )
      };
    })
    .filter(Boolean);

  return (
    <div className={classes.container}>
      {mappedGroups.map((group: any, index: number) => {
        return (
          <div key={`${group.name}-${index}`} style={{ paddingBottom: '10px' }}>
            <div
              className={`${classes.box} ${isForFactSheet ? classes.big : ''}`}
            >
              <div className={classes.itemBox}>
                <span
                  style={{ marginRight: '4px' }}
                  className={`${classes.name} ${classes.bold}`}
                >
                  {group.name}
                </span>
                {group.tooltip && !isForReport && (
                  <Tooltip
                    text={
                      <div
                        dangerouslySetInnerHTML={{ __html: group.tooltip }}
                      ></div>
                    }
                    size={20}
                  />
                )}
              </div>
              <div className={`${classes.valueBox} ${classes.bold}`}>
                <span>{formatPercent(group.value)}</span>
              </div>
            </div>
            {group.items.map((key: string) => {
              return (
                <div key={key}>
                  <div
                    className={`${classes.box} ${isForFactSheet ? classes.big : ''}`}
                  >
                    <div className={classes.itemBox}>
                      <div
                        className={classes.colorBox}
                        style={{
                          backgroundColor:
                            palette[subKeys.findIndex(subKey => subKey === key)]
                        }}
                      />
                      <span className={`${classes.name} ${classes.flexGrow}`}>
                        {key}
                      </span>
                    </div>
                    <div className={classes.valueBox}>
                      <span>
                        {formatPercent(
                          data.find((entry: any) => entry.name === key)
                            ?.value || 0
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default Legend;
